<template lang="pug">
  .site-message-banner(v-if="hasMessage")
    .row.color-white.text-center.xs-f-small.lg-f-medium.max-at-tweak(v-if="oneMessage" v-bind:style="{'background-color': backgroundColor(messages[0])}")
      .xs-12(v-html="messages[0].message")
    slick.sitewide-carousel(v-else ref="carousel" v-bind="carouselOptions")
      .row.color-white.text-center.xs-f-small.lg-f-medium.max-at-tweak(v-for="message in messages" :style="{'background-color': backgroundColor(message)}")
        .xs-12(v-html="message.message")

</template>

<script>
  import vueSiteMessageSvc from '../../services/vueSiteMessageSvc';

  export default {
    name: "SiteMessageBanner",

    props: {
      topics: {
        type: String
      }
    },

    data() {
      return {
        carouselOptions: {
          autoplay: true,
          autoplaySpeed: 8000,
          speed: 1500,
          cssEase: 'ease-in-out',
          infinite: true,
          dots: false,
          prevArrow: false,
          nextArrow: false,
          slidesToShow: 1,
        },
      };
    },

    computed: {
      hasMessage() {
        return !!(this.messages && this.messages.length);
      },

      oneMessage() {
        return this.messages && this.messages.length == 1;
      }
    },

    asyncComputed: {
      messages: {
        lazy: true,
        get() {
          if (this.topics) {
            // There should only ever be one global message
            return vueSiteMessageSvc.getByTopics({ topics: this.topics }).then(res => res.data);
          }
        }
      }
    },
    methods: {
      backgroundColor(message) {
        if (message.background_color) {
          return message.background_color;
        }
        return "#000";
      }
    }
  };
</script>

<style lang="stylus">
  .site-message-banner
    .row
      max-width 100%
      padding 1.2em 5%

</style>
